<!-- 申请加入 -->
<template>
  <div class="join-container">
    <div class="background"></div>
    <Header></Header>
    <div class="main">
      <el-row class="middle">
        <el-col class="middleRight">
          <el-row type="flex" justify="center">
            <el-col :xs="24" :sm="20" :md="20" :lg="20" :xl="20">

              <div class="join-main">
                <div>
                	<div class="content" v-html="content"></div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        content:null,
      };
    },

    components: {},

    mounted() {
    	this.getInfo()
    },

    methods: {
    	getInfo()
    	{
    	  this.instance.get('/api/contact/getinfo',{

    	  }).then(res=>{
    	    if(res.status==200)
    	    {
    	      let data=res.data;
    	      this.content=data.content;
    	    }
    	  })
    	},
    },
  }

</script>
<style scoped>
  .join-container::before {
    content: '';
    display: table;
  }

  .join-main {
    /* width: 1600px; */
    position: relative;
    width: 100%;
    height: 520px;
    padding: 80px;
    margin: 0 auto 40px auto;
    overflow: hidden;
    color: #3C4A5D;
    /* background-color: rgba(255, 255, 255, 0.85); */
    background-color: white;
    /* border: 1px solid red; */
  }

  .join-main>h3 {
    margin: 40px 0 20px 0;
  }

  .join-main>div {
    margin: 20px 20px;
  }

</style>



// WEBPACK FOOTER //
// src/views/Join.vue